import { toast } from 'react-toastify';
import errorHandle from '../../../../utils/errorHandle';
import { tripAvaFun } from '../../../../api/bookingAPI';
import moment from 'moment';
import { trackEvent } from '../../../../utils/analytics';
import { detailsRoute } from '../../../../utils/detailsRoute';

export default async function tripBookingClick(
    booking,
    setBookingData,
    setReviewPage,
    tripData,
    amount,
    setLoading,
    packDates,
    setShowAppOnlyPopup
) {
    if (tripData.appOnly === true) {
        setShowAppOnlyPopup(true);
        return;
    }

    if (booking.transport === '-1') {
        toast.error('Please select a transport option');
        return;
    } else if (booking.transport === 'With transport') {
        if (!booking.date || booking.date === '-1') {
            toast.error('Please select date');
            return;
        }
        if (booking.startCity === '') {
            toast.error('Please select start city');
            return;
        }
        if (booking.pickupLocation === '') {
            let text = booking.group === 'vehicle' ? 'Please select meetup location' : 'Please select pickup location';
            toast.error(text);
            return;
        }
        if (booking.group === 'vehicle') {
            if (booking?.vehicleType === '' || booking?.vehicleType === '-1') {
                toast.error('Please select vehicle');
                return;
            }
            if (booking?.vehicleType === 'Self Car' || booking?.vehicleType === 'Self Bike') {
                if (booking.vehicleModel === '') {
                    toast.error('Please enter vehicle model');
                    return;
                }
            }
        }
        // if (booking?.vehicleType === '') {
        //     toast.error('Please select vehicle');
        //     return;
        // }
        // if (booking?.vehicleModel === '') {
        //     toast.error('Please enter vehicle model');
        //     return;
        // }

        // if (booking?.comfortable === '') {
        //     toast.error('Please select comfort level');
        //     return;
        // }
        // const requiredFields = ['date', 'startCity', 'pickupLocation'];

        // const missingFields = requiredFields.filter((field) => !booking[field]);
        // if (booking.pickupLocation === '-1' || missingFields.length > 0) {
        //     toast.error('Please fill all required fields.');
        //     return;
        // }
    }
    setLoading(true);
    try {
        const { packId, type } = detailsRoute();
        let id;
        packDates.forEach((element) => {
            if (
                new Date(element.startDate).toISOString().split('T')[0] ===
                new Date(booking.date).toISOString().split('T')[0]
            ) {
                id = element._id;
            }
        });
        const checkAva = await tripAvaFun({
            packDateId: id,
            slots: booking.people,
            rooms: booking.room
        });
        const offerCode = booking.isInstallment ? '' : booking.offerCode;
        const finalAmount = booking.isInstallment ? { ...amount, offerAmo: 0 } : { ...amount };

        if (checkAva.data.status === true) {
            // Track successful booking start
            trackEvent({
                event: 'booking_started',
                page: window.location.pathname + window.location.search,
                tripId: packId,
                dateId: id,
                metadata: {
                    people: booking?.people || 0,
                    rooms: booking?.room || 0,
                    transport: booking?.transport || null
                }
            });
            setBookingData({
                ...booking,
                offerCode,
                ...finalAmount,
                title: tripData.title,
                packDateId: id,
                packId: packId,
                organizerId: tripData.organizerId,
                organizerName: tripData.organizerName,
                type: type,
                days: tripData.days,
                nights: tripData.nights,
                tripImage: tripData.images[0]
            });
            setReviewPage(true);
            setLoading(false);
        } else {
            setLoading(false);
            if (checkAva.data.remainingRooms < booking.room)
                toast.error('Only ' + checkAva.data.remainingRooms + ' room is available');
            else toast.error('Only ' + checkAva.data.remainingSlots + ' slots are available');
        }
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
}

// Handle cutsome trip booking
export const handleCustomTripBooking = ({
    booking,
    customBooking,
    packData,
    customFinalPrice,
    setBookingData,
    setReviewPage,
    setShowAppOnlyPopup
}) => {
    if (packData.appOnly === true) {
        setShowAppOnlyPopup(true);
        return;
    }
    if (customBooking.startDate === null || customBooking.endDate === null) {
        toast.error('Please Select Date');
        return;
    } else if (customBooking.startCity === '' || customBooking.startCity === '-1') {
        toast.error('Please select start city');
        return;
    } else if (customBooking.pickupLocation === '' || customBooking.pickupLocation === '-1') {
        let text = booking.group === 'vehicle' ? 'Please select meetup location' : 'Please select pickup location';
        toast.error(text);
        return;
    } else if (!customBooking?.customTrip?.isGroup) {
        if (
            !customBooking.customTrip.vehicleType ||
            !customBooking.customTrip.vehicleType.some((v) => v.vehicleCount > 0)
        ) {
            toast.error('Please Select Vehicle');
            return;
        }
    }
    const totalAdults = customBooking?.customTrip?.people;
    setBookingData({
        type: 'trip',
        title: packData.title,
        ...customBooking,
        startDate: customBooking.startDate.utc().toISOString(),
        endDate: customBooking.endDate.utc().toISOString(),
        packId: packData._id,
        packDateId: null,
        datesType: packData.datesType,
        group: packData.group,
        itiType: packData.itiType,
        tripImage: packData.images[0],
        organizerId: packData.organizerId,
        organizerName: packData.organizerName,
        people: totalAdults,
        days: packData.days,
        nights: packData.nights
    });

    setReviewPage(true);
};

// Handle update booking click
export const handleUpdateNow = async ({
    type,
    dataToBeUpdated,
    selectedDate,
    confirmedBookingData,
    updateUserBookingDateAndPickupLocation,
    naviagte
}) => {
    let newDate =
        confirmedBookingData.datesType === 'custom'
            ? moment(dataToBeUpdated.startDate).toISOString()
            : dataToBeUpdated?.date;
    let endDate =
        confirmedBookingData.datesType === 'custom'
            ? moment(dataToBeUpdated.endDate).toISOString()
            : selectedDate?.endDate;
    const updateDateBody = {
        bookingId: confirmedBookingData?._id,
        newDate: newDate,
        endDate: endDate
    };

    const updatePickupLocationBody = {
        bookingId: confirmedBookingData?._id,
        pickupLocation: dataToBeUpdated?.pickupLocation
    };

    try {
        const dateFlag = confirmedBookingData.startDate && !confirmedBookingData?.isTripMoreThanOneDays;
        const pickupFlag = confirmedBookingData?.isTripMoreThanOneDays;

        if (dateFlag) {
            const response = await updateUserBookingDateAndPickupLocation(type, dateFlag, false, updateDateBody);
            if (response.status === 200) {
                toast.success('You have Rescheduled the date successfully');
                sessionStorage.removeItem('confirmedBookingData');
                naviagte('/my-booking');
            }
        } else if (pickupFlag) {
            const response = await updateUserBookingDateAndPickupLocation(
                type,
                false,
                pickupFlag,
                updatePickupLocationBody
            );
            if (response.status === 200) {
                toast.success('You have changed the location successfully');
                sessionStorage.removeItem('confirmedBookingData');
                naviagte('/my-booking');
            }
        }
    } catch (error) {
        toast.warning(error.response.data.message);
        console.error('Error updating booking:', error);
    }
};
